import type { Locale } from "@/i18n/lang";
import { t } from "@/i18n/lang";
import { pathNames } from "@/router/paths";

export type NavLink = {
  labelKey: string;
  path: string;
};

export type Product = {
  slug: string;
  nameKey: string;
  priceKey: string;
  descriptionKey?: string;
};

export type PolicyKey = "manual" | "privacy" | "refund";

const POLICY_TITLE_KEYS: Record<PolicyKey, string> = {
  manual: "policy.manual",
  privacy: "policy.privacy",
  refund: "policy.refund",
};

export const products: Product[] = [
  {
    slug: "yoyo-gen1",
    nameKey: "product.name",
    priceKey: "product.price",
    descriptionKey: "product.description",
  },
  {
    slug: "yoyo-gen1",
    nameKey: "product.name",
    priceKey: "product.price",
    descriptionKey: "product.description",
  },
];

export const navProducts: NavLink[] = [
  { labelKey: "nav.yoyo", path: pathNames.productDetail("yoyo-gen1") },
];

export const navSupport: NavLink[] = [
  { labelKey: "nav.faq", path: pathNames.faq },
  { labelKey: "nav.privacy", path: pathNames.privacy },
  { labelKey: "nav.contact", path: pathNames.contact },
  { labelKey: "nav.refund", path: pathNames.refund },
];

export const serviceBadges = [
  { titleKey: "service.freeShipping", descKey: "service.freeShippingDesc" },
  {
    titleKey: "service.customerService",
    descKey: "service.customerServiceDesc",
  },
  { titleKey: "service.securePayment", descKey: "service.securePaymentDesc" },
  { titleKey: "service.warranty", descKey: "service.warrantyDesc" },
];

export const homeCategories = [
  {
    titleKey: "home.categoryYoyo",
    descKey: "home.categoryYoyoDesc",
    path: pathNames.productDetail("yoyo-gen1"),
  },
  {
    titleKey: "home.categoryApp",
    descKey: "home.categoryAppDesc",
    path: pathNames.about,
  },
  {
    titleKey: "home.categorySupport",
    descKey: "home.categorySupportDesc",
    path: pathNames.faq,
  },
];

export const homeFeatures = [
  { titleKey: "home.featSmart", descKey: "home.featSmartDesc" },
  { titleKey: "home.featVoice", descKey: "home.featVoiceDesc" },
  { titleKey: "home.featGrowth", descKey: "home.featGrowthDesc" },
  { titleKey: "home.featSafety", descKey: "home.featSafetyDesc" },
  { titleKey: "home.featConnect", descKey: "home.featConnectDesc" },
  { titleKey: "home.featService", descKey: "home.featServiceDesc" },
];

export const homeTestimonials = [
  { authorKey: "home.review1Author", contentKey: "home.review1Text" },
  { authorKey: "home.review2Author", contentKey: "home.review2Text" },
  { authorKey: "home.review3Author", contentKey: "home.review3Text" },
  { authorKey: "home.review4Author", contentKey: "home.review4Text" },
  { authorKey: "home.review5Author", contentKey: "home.review5Text" },
  { authorKey: "home.review6Author", contentKey: "home.review6Text" },
];

export const homePressLogos = [
  "TechCrunch",
  "36Kr",
  "IF Design",
  "Red Dot",
  "YOYO Lab",
  "Family Choice",
];

export const homeServiceBadges = [
  { titleKey: "service.freeShipping", descKey: "service.freeShippingHomeDesc" },
  { titleKey: "service.customerFirst", descKey: "service.customerFirstDesc" },
  { titleKey: "service.securePayment", descKey: "service.securePaymentDesc" },
  { titleKey: "service.warranty", descKey: "service.warrantyDesc" },
];

export const productColors = [
  { id: "off-white", labelKey: "product.colorOffWhite" },
  { id: "space-gray", labelKey: "product.colorSpaceGray" },
];

export const productSizes = [
  { id: "gen1-s", labelKey: "product.sizeS" },
  { id: "gen1-m", labelKey: "product.sizeM" },
];

export const productSpecs = [
  { id: "spec1", labelKey: "product.spec1" },
  { id: "spec2", labelKey: "product.spec2" },
  { id: "spec3", labelKey: "product.spec3" },
];

export const productAttributes = [
  {
    labelKey: "product.attrProductSize",
    valueKey: "product.attrProductSizeValue",
  },
  {
    labelKey: "product.attrPackageSize",
    valueKey: "product.attrPackageSizeValue",
  },
];

export const usageScenarios = [
  { icon: "听", labelKey: "product.listen" },
  { icon: "看", labelKey: "product.see" },
  { icon: "说", labelKey: "product.speak" },
  { icon: "想", labelKey: "product.think" },
  { icon: "动", labelKey: "product.move" },
];

export const usageFeatures = [
  {
    titleKey: "product.featureEmotionalTitle",
    descKey: "product.featureEmotionalDesc",
  },
  {
    titleKey: "product.featureStoryTitle",
    descKey: "product.featureStoryDesc",
  },
  {
    titleKey: "product.featureEducationTitle",
    descKey: "product.featureEducationDesc",
  },
];

export const appFeatures = [
  "product.appFeature1",
  "product.appFeature2",
  "product.appFeature3",
  "product.appFeature4",
  "product.appFeature5",
];

export const evolutionStages = [
  { titleKey: "product.stageRecord", descKey: "product.stageRecordDesc" },
  {
    titleKey: "product.stageUnderstand",
    descKey: "product.stageUnderstandDesc",
  },
  { titleKey: "product.stageRemember", descKey: "product.stageRememberDesc" },
  { titleKey: "product.stageFeedback", descKey: "product.stageFeedbackDesc" },
  { titleKey: "product.stageEvolve", descKey: "product.stageEvolveDesc" },
];

export const aboutMission = [
  { titleKey: "about.mission", descKey: "about.missionDesc" },
  { titleKey: "about.vision", descKey: "about.visionDesc" },
  { titleKey: "about.values", descKey: "about.valuesDesc" },
];

export function getPolicyTitle(locale: Locale, policyKey: PolicyKey): string {
  return t(locale, POLICY_TITLE_KEYS[policyKey]);
}

export function getPolicyParagraphs(locale: Locale): string[] {
  return Array(4).fill(t(locale, "faq.answer")) as string[];
}
